import { render, staticRenderFns } from "./AdsItem.vue?vue&type=template&id=157cdf4b&scoped=true&"
import script from "./AdsItem.vue?vue&type=script&lang=js&"
export * from "./AdsItem.vue?vue&type=script&lang=js&"
import style0 from "./AdsItem.vue?vue&type=style&index=0&id=157cdf4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157cdf4b",
  null
  
)

export default component.exports